import { Link } from "gatsby";
import React from "react";

export interface FooterSubSegmentItem {
  icon?: string;
  url?: string;
  name: string;
}

interface Props {
  label: string;
  items: FooterSubSegmentItem[];
}

export const FooterSubSegment = (props: Props) => {
  return (
    <div className="max-w-sm text-center md:text-left">
      <div className="mb-6 opacity-50">{props.label}</div>
      <ul className="flex flex-col gap-3">
        {props.items.map((item, index) => (
          <li key={index}>
            {item.url && <Link className="whitespace-nowrap" to={item.url}>{item.name}</Link>}
            {!item.url && item.name}
          </li>
        ))}
      </ul>
    </div>
  );
};
